<template>
  <div>
    <Card>
      <password-reset v-if="type==passwordResetType" :form="form" @handlePreview='handlePreview' />
      <integral-unit v-if="type==integralUnitType" :form="form" @handlePreview='handlePreview' />
      <unit-withdraw v-if="type==unitWithdrawType" :form="form" @handlePreview='handlePreview' />
      <address-change v-if="type==addressChangeType" :form="form" @handlePreview='handlePreview' />
      <unit-change v-if="type==unitChangeType" :form="form" @handlePreview='handlePreview' />
      <cancel-information v-if="type==cancelInformationType" :form="form" @handlePreview='handlePreview' />
    </Card>
  </div>
</template>
<script>
import '../residencePermitIntegral/styles/points.less'
import PasswordReset from './modules/passwordReset/index.vue'
import IntegralUnit from './modules/integralUnit/index.vue'
import UnitWithdraw from './modules/unitWithdraw/index.vue'
import AddressChange from './modules/addressChange/index.vue'
import UnitChange from './modules/unitChange/index.vue'
import CancelInformation from './modules/cancelInformation/index.vue'

export default {
  components: {
    PasswordReset,
    IntegralUnit,
    UnitWithdraw,
    AddressChange,
    UnitChange,
    CancelInformation,
  },
  data() {
    return {
      form: {
        otherFileGuidListPreview: [],
        resetPasswordPdfGuidListPreview: [],
        hrPermitGuidListPreview: [],
        socialInsuranceRegGuidListPreview: [],
        returnWorkOrderFileGuidListPreview: [],
        laborContractFileGuidListPreview: [],
        logoutApplicationFormGuidPreview: [],
        childrenList: [],
        hrPermitGuidPreview: [],
      },
      guid: '',
      type: null,
      passwordResetType: null,
      integralUnitType: null,
      unitWithdrawType: null,
      addressChangeType: null,
      unitChangeType: null,
      cancelInformationType: null,
    }
  },
  async mounted() {
    //获取*
    let guid = this.$route.query.guid
    this.type = this.$route.query.type
    this.getTypeValue()
    // await this.getFullInfo()
    // 判断业务类型 获取数据
    if (guid) {
      if (this.type == this.passwordResetType) {
        // 密码重置
        this.getInitPasswordReset(guid)
        return
      }
      if (this.type == this.integralUnitType) {
        // 单位开户/单位信息变更
        this.getInitintegralUnit(guid)
        return
      }
      if (this.type == this.unitWithdrawType) {
        // 单位撤回申请
        this.getInitunitWithdraw(guid)
        return
      }
      if (this.type == this.addressChangeType) {
        // 积分有效期内变更居住地址
        this.getInitaddressChange(guid)
        return
      }
      if (this.type == this.unitChangeType) {
        // 有效期内变更单位
        this.getInitunitChangeType(guid)
        return
      }
      if (this.type == this.cancelInformationType) {
        // 注销申请人积分、配偶子女信息
        this.getInitcancelInformation(guid)
        return
      }
    }
  },
  methods: {
    //获取类型值
    getTypeValue() {
      this.passwordResetType = this.$store.state.otherApplicationTypeList.find(
        (applicationType) => {
          return applicationType.text == '密码重置'
        }
      ).value
      this.integralUnitType = this.$store.state.otherApplicationTypeList.find((applicationType) => {
        return applicationType.text == '单位开户/单位信息变更'
      }).value
      this.unitWithdrawType = this.$store.state.otherApplicationTypeList.find((applicationType) => {
        return applicationType.text == '单位撤回申请'
      }).value
      this.addressChangeType = this.$store.state.otherApplicationTypeList.find(
        (applicationType) => {
          return applicationType.text == '积分有效期内变更居住地址'
        }
      ).value
      this.unitChangeType = this.$store.state.otherApplicationTypeList.find((applicationType) => {
        return applicationType.text == '有效期内变更单位'
      }).value
      this.cancelInformationType = this.$store.state.otherApplicationTypeList.find(
        (applicationType) => {
          return applicationType.text == '注销申请人积分、配偶子女信息'
        }
      ).value
    },
    //密码重置
    async getInitPasswordReset(guid) {
      this.loading = true
      let { data } = await this.$Ajax.get(
        '/api/services/app/OtherApplicationApi/GetFullInfoByResetPassword',
        { params: { guid } }
      )
      this.form = data.result

      this.loading = false
    },
    //单位开户/单位信息变更
    async getInitintegralUnit(guid) {
      this.loading = true
      let { data } = await this.$Ajax.get(
        '/api/services/app/OtherApplicationApi/GetFullInfoByOpenAccount',
        { params: { guid } }
      )
      this.form = data.result

      this.loading = false
    },
    // 单位撤回申请
    async getInitunitWithdraw(guid) {
      this.loading = true
      let { data } = await this.$Ajax.get(
        '/api/services/app/OtherApplicationApi/GetFullInfoByUnitWithdrawal',
        { params: { guid } }
      )
      this.form = data.result

      this.loading = false
    },
    //积分有效期内变更居住地址
    async getInitaddressChange(guid) {
      this.loading = true
      let { data } = await this.$Ajax.get(
        '/api/services/app/OtherApplicationApi/GetFullInfoByChangeDomicileAddress',
        { params: { guid } }
      )
      this.form = data.result

      this.loading = false
    },
    //有效期内变更单位
    async getInitunitChangeType(guid) {
      this.loading = true
      let { data } = await this.$Ajax.get(
        '/api/services/app/OtherApplicationApi/GetFullInfoByChangeUnit',
        { params: { guid } }
      )
      this.form = data.result

      this.loading = false
    },
    //注销申请人积分、配偶子女信息
    async getInitcancelInformation(guid) {
      this.loading = true
      let { data } = await this.$Ajax.get(
        '/api/services/app/OtherApplicationApi/GetFullInfoByLogoutApplicantPoints',
        { params: { guid } }
      )
      this.form = data.result

      this.loading = false
    },
    //查看文件
    handlePreview(file) {
      if (typeof file !== 'object') {
        //单个图片
        // window.open(this.$baseURL + '/file/preview/' + file)
        const $viewer = this.$viewerApi({
          options: {
            toolbar: true,
            initialViewIndex: 0,
          },
          images: [this.$baseURL + '/file/preview/' + file],
        })
        return
      }
      let _this = this
      if (file.url) {
        let fileExtension
        if (file.name.indexOf('.') >= 0) {
          fileExtension = file.name.split('.').pop().toLowerCase()
        } else {
          fileExtension = ''
        }
        console.log('🚀 ~ handlePreview ~ fileExtension:', fileExtension)

        if (fileExtension === 'jpg' || fileExtension === 'jpeg' || fileExtension === 'png') {
          const $viewer = this.$viewerApi({
            options: {
              toolbar: true,
              initialViewIndex: 0,
            },
            images: [_this.$baseURL + file.url],
          })
          return
        }
        window.open(this.$baseURL + file.url)
        return
      }
      if (file.status == 'finished') {
        let fileExtension
        if (file.url.indexOf('.') >= 0) {
          fileExtension = file.response.result.fileName.split('.').pop().toLowerCase()
        } else {
          fileExtension = ''
        }
        if (fileExtension === 'jpg' || fileExtension === 'jpeg' || fileExtension === 'png') {
          const $viewer = this.$viewerApi({
            options: {
              toolbar: true,
              initialViewIndex: 0,
            },
            images: [_this.$baseURL + file.response.result.imageUrl],
          })
          return
        }
        window.open(this.$baseURL + file.response.result.imageUrl)
      }
    },
  },
}
</script>